module.exports = __webpack_public_path__ + "img/data_one_bottom.0767a214.gif";